import * as React from 'react';
import { Box } from '@mantine/core';

// Components
import { HelpTooltipButton } from '../../HelpTooltipButton';

interface FieldLabelTooltipProps {
    translationKey?: string;
    translationNamespace?: string;
}

export const FieldLabelTooltip: React.FC<FieldLabelTooltipProps> = ({
    translationKey,
    translationNamespace,
    ...props
}) => {
    return (
        <Box mx={2} style={{ display: 'inline-block' }}>
            <HelpTooltipButton labelKey={translationKey} translationNamespace={translationNamespace} />
        </Box>
    );
};
